module.exports = __webpack_public_path__ + "static/media/redtube.ca470f25.png";